(function () {
  'use strict';

  var ROHR_M2   = 6.7;  // m Heizrohr pro m² bei 15 cm Abstand
  var PIPE_LEN  = 200;  // m pro Rohrrolle (alle Systeme)
  var RAND_LEN  = 50;   // m pro Randdämmstreifen-Paket

  var MAX_KREIS = { tacker: 100, klett: 80, duennschicht: 80, trockenbau: 80 };

  var LABELS = {
    tacker:       'Tackersystem: Materialkosten nach Fläche',
    klett:        'Klettsystem: Materialkosten nach Fläche',
    duennschicht: 'Dünnschichtsystem: Materialkosten nach Fläche',
    trockenbau:   'Trockenbausystem: Materialkosten nach Fläche',
  };

  var SUB = {
    tacker:       'Basis: EPS WLG 040, 30 mm · PE-Xa 16mm',
    klett:        'Basis: MC KLETT Slim · Klett PE-Xa 16mm',
    duennschicht: 'Basis: NerthusFlow 16er · PE-Xa 16mm',
    trockenbau:   'Basis: EPS 300 + Wärmeleitblech · PE-RT-ALU 16mm',
  };

  function calcTotal(p, area) {
    var pipeM = area * ROHR_M2;
    var pipeRolls = Math.ceil(pipeM / PIPE_LEN);
    var randPerim = 4 * Math.sqrt(area);
    var randPacks = Math.ceil(randPerim / RAND_LEN);

    var ins, wlb = 0;

    if (p.system === 'trockenbau') {
      // EPS 300 elements (0.72 m² each) + Wärmeleitblech 16 mm packs (50 Stk × 0.997 m)
      ins = Math.ceil(area / p.ins_pack) * p.ins;
      var wlbStk = Math.ceil(pipeM / 0.997);
      wlb = Math.ceil(wlbStk / 50) * p.wlb;
    } else if (p.system === 'klett') {
      // KLETT Slim: 10 m² / pack
      ins = Math.ceil(area / p.ins_pack) * p.ins;
    } else {
      // Tacker + Dünnschicht: 10 m² / pack (ins_pack = 10)
      ins = Math.ceil(area / p.ins_pack) * p.ins;
    }

    var pipe = pipeRolls * p.pipe;
    var rand = randPacks * p.rand;

    var nadeln = 0;
    if (p.system === 'tacker') {
      var nadelAnzahl = Math.ceil(pipeM / 0.35);
      nadeln = Math.min(
        Math.ceil(nadelAnzahl / 300) * 4.60,
        Math.ceil(nadelAnzahl / 1000) * 15.70
      );
    }

    return ins + pipe + wlb + rand + nadeln;
  }

  function fmt(n) {
    return n.toLocaleString('de-DE');
  }

  function render(el, p) {
    var system   = p.system;
    var maxKreis = MAX_KREIS[system] || 80;
    var rows     = '';

    for (var area = 10; area <= 200; area += 10) {
      var total   = calcTotal(p, area);
      var rounded = Math.ceil(total / 10) * 10;
      var pipeM   = Math.round(area * ROHR_M2 / 5) * 5;
      var kreise  = Math.ceil(area * ROHR_M2 / maxKreis);

      rows += '<tr>'
        + '<td>' + area + ' m²</td>'
        + '<td>' + pipeM + ' m</td>'
        + '<td>' + kreise + '</td>'
        + '<td><strong>ab ' + fmt(rounded) + ' €</strong></td>'
        + '</tr>';
    }

    var month = new Date().toLocaleDateString('de-DE', { month: 'long', year: 'numeric' });

    el.innerHTML =
      '<h2 class="kpro-ptable-heading">' + (LABELS[system] || '') + '</h2>'
      + '<p style="font-size:13px;color:#606070;margin:-8px 0 14px">' + (SUB[system] || '') + '</p>'
      + '<div class="kpro-ptable-wrap"><table class="kpro-ptable">'
      + '<thead><tr>'
      + '<th>Fläche</th>'
      + '<th>Heizrohr</th>'
      + '<th>Heizkreise</th>'
      + '<th>Materialkosten ab</th>'
      + '</tr></thead>'
      + '<tbody>' + rows + '</tbody>'
      + '</table></div>'
      + '<p class="kpro-ptable-note">'
      + 'Ohne Heizkreisverteiler, Steuerung und Estrich. Inkl. MwSt. '
      + 'Preise aktuell (' + month + ').'
      + '</p>';
  }

  function init() {
    document.querySelectorAll('[data-preistabelle]').forEach(function (el) {
      var ptId   = el.dataset.ptId;
      var script = ptId ? document.getElementById(ptId) : null;
      if (!script) return;

      var p;
      try { p = JSON.parse(script.textContent); } catch (e) { return; }
      if (!p || !p.system) return;

      render(el, p);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
